import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
    liEkycDetails:{}
  };

const fetchLiEkyc = (state,action)=>{
    return updateObject(state, {
        formData: action.formData,
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
      // lead
      case actionTypes.FETCH_LI_EKYC_DETAILS:
          return fetchLiEkyc(state,action);
      default:
        return state;
    }
  };
  
  export default reducer;